var chunkMapping = {
	"471": [
		65471
	]
};
var idToExternalAndNameMapping = {
	"65471": [
		"default",
		"./ExternalWrapper",
		76012
	]
};
var idToRemoteMap = {
	"65471": [
		{
			"externalType": "script",
			"name": "ae2-2",
			"externalModuleId": 76012
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}